module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Extra-Bold.f4bfcc1.woff2";